import reactivate from './jobseekerReactivate';

const unsubcribeForm = document.querySelector('.js-unsubscribe-form');
if (unsubcribeForm) {
  unsubcribeForm.addEventListener('submit', (event) => {
    event.preventDefault();

    const unsubscribeInfo = JSON.parse(unsubcribeForm.dataset.unsubscribeInfo);

    reactivate(unsubscribeInfo || undefined);
  });
}
